import type * as React from 'react';
import { DropdownMenuOption } from '@ardoq/dropdown-menu-ui';
import { GroupBase, OptionProps } from 'react-select';
import { AxisSourceOption } from './types';

type SourceOptionProps = OptionProps<
  AxisSourceOption,
  false,
  GroupBase<AxisSourceOption>
> & { onDeselect: VoidFunction };

export const SourceOption = ({
  innerRef,
  innerProps,
  isSelected,
  isFocused,
  isDisabled,
  data,
  onDeselect,
}: SourceOptionProps) => (
  <DropdownMenuOption
    ref={innerRef as React.Ref<HTMLDivElement>}
    isChecked={isSelected}
    label={data.labelNode ?? data.label}
    isDisabled={isDisabled}
    isFocused={isFocused}
    isHovered={isFocused}
    rightContent={data.labelNode ? undefined : data.rightContent}
    menuOptionWrapperProps={{
      ...innerProps,
      onClick: e => {
        if (isSelected) {
          e.preventDefault();
          e.stopPropagation();
          onDeselect();
          return;
        }
        innerProps.onClick?.(e);
      },
    }}
  />
);
